<template>
    <div>
        <div class="tower"></div>
        <div class="sky"></div>
    </div>
</template>

<script>
    export default {
        name: "MoscowCityTower"
    }
</script>

<style scoped>
    .sky {
        height: 100vh;
        background-color: #354150;
        z-index: 5;
    }
    .tower {
        height: 70vh;
        width: 40vw;
        background: rgb(53,65,80);
        background: linear-gradient(180deg, rgba(53,65,80,1) 0%, rgba(122,138,158,1) 100%);
        position: absolute;
        top: 30vh;
        left: 30vw;
        z-index: 10;
        transform: rotate(0deg) skew(355deg);
        perspective: 250px;
    }
</style>